import notificationCommitTypes from './commit-types';

const INITIAL_NOTIFICATIONS = {
  queue: [],
  list: [],
  map: {}
};

function notificationReducers(state = INITIAL_NOTIFICATIONS, action) {

  if (!action || !action.type) {
    return state;
  }

  switch (action.type) {
    case notificationCommitTypes.ADD_NOTIFICATION_TO_QUEUE:
      return {
        queue: [ ...state.queue, action.notification]
      };
    case  notificationCommitTypes.REMOVE_NOTIFICATION_TO_QUEUE:
      return {
        queue: state.queue.filter(n => n.id !== action.notificationId)
      };
    case  notificationCommitTypes.MARK_NOTIFICATION_FOR_REMOVE:
      return {
        queue: state.queue.map(notification => {
          return notification.id === action.notificationId
          ? {
            ...notification,
            remove: true
          }
          : notification;
        })
      };
    case  notificationCommitTypes.RETRY_TEST:
      console.log('action ', action)
      return {
        ...state,
        list: state.list.map(tt => tt.id === action.test.id ? action.test : tt),
        map: {
          ...state.list,
          [action.test.id]: action.test
        }
      };

    default: {
      return state;
    }
  }
}

export default notificationReducers;

